import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'

import {
  priceFieldProps,
  priceRegisterConfig,
  urlRegisterConfig,
} from './Fields/config'
import ConfirmedBooking from './Fields/ConfirmedBooking'
import Input from './Fields/RHFInput'
import TextArea from './Fields/RHFTextArea'
import StartEndAddressFields from './Fields/StartEndAddressFields'
import StartEndDateTimeFields from './Fields/StartEndDateTimeFields'
import { useDefaultDatePickerMonthYear } from './Hooks/useDefaultDates'
import type { CreateOtherTransportItemViewModel } from '../Create/models'
import type { PatchOtherTransportItemViewModel } from '../Edit/models'

import type { AutocompletePlaceParam } from 'tripPlanner/types/google'

const AUTOCOMPLETE_TYPES: AutocompletePlaceParam = []

interface Props {
  tripId: string
}

function OtherTransportFields({ tripId }: Props) {
  const methods = useFormContext<
    CreateOtherTransportItemViewModel | PatchOtherTransportItemViewModel
  >()
  const { control, watch, register } = methods

  const { defaultMonth, defaultYear } = useDefaultDatePickerMonthYear({
    tripId,
  })

  const watchBooked = watch('isBooked')

  return (
    <>
      <StartEndAddressFields
        autocompleteTypes={AUTOCOMPLETE_TYPES}
        tripId={tripId}
      />
      <StartEndDateTimeFields
        startDateLabel="Departure date"
        endDateLabel="Arrival date"
        defaultMonth={defaultMonth}
        defaultYear={defaultYear}
      />
      <Input
        {...register('operatorName')}
        label="Operator"
        placeholder="Operator"
      />

      <Input
        {...register('url', { ...urlRegisterConfig })}
        label="Website"
        placeholder="Website"
      />

      <Controller
        name="isBooked"
        control={control}
        render={({ field }) => (
          <ConfirmedBooking
            toggled={!!field.value}
            onToggle={() => field.onChange(!field.value)}
          />
        )}
      />

      {watchBooked && (
        <>
          <Input
            {...register('confirmationCode')}
            label="Confirmation number"
            placeholder="Confirmation number"
          />

          <Input {...register('seat')} label="Seat" placeholder="Seat number" />
        </>
      )}

      <Input
        {...register('price', { ...priceRegisterConfig })}
        label="Price"
        placeholder="Price"
        {...priceFieldProps}
      />

      <TextArea
        {...register('notes')}
        placeholder="Add notes about this booking"
        label="Additional notes"
        resize="vertical"
      />
    </>
  )
}

export default OtherTransportFields
